import LOGO from "../images/Llamas.png";

export const Team__Llamas = {
  name: "Llamas",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#111111",
  teamJerseyColor: "#222222",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 42 + 37 + 58,
  goalsScoredAgainst: 34 + 34 + 21,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
